import React, { useEffect, useState } from "react";
import AdminLandingPage from "./AdminLandingPage";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import { useDispatch } from "react-redux";
import { fetchRapdidAdminLandingPage } from "../../../services/api";
import Loader from "../../../components/Loader/Loader";
import { useSelector } from "react-redux";
import NoAccess from "../../NoAccess/NoAccess";
import Error from "../Component/Error";

function AdminLandingPageContainer() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    status: "loading",
    message: "Loading Admin Landing Page",
  });
  const [data, setData] = useState([]);

  const is_admin =
    useSelector((state) => state.auth.metadata?.rapid?.is_admin) || false;

  const getAdminLandingPageData = async () => {
    setLoading({
      status: "loading",
      message: "Loading Admin Landing Page",
    });

    try {
      const resp = await fetchRapdidAdminLandingPage();

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        const data = resp.data?.data?.requests;
        setData(data);
        setLoading({
          status: "success",
          message: "Admin Landing Page Loaded",
        });
      } else {
        setLoading({
          status: "error",
          message: message,
        });
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      setLoading({
        status: "error",
        message: "Internal Server Error",
      });
      console.error("Error", err);
    }
  };

  useEffect(() => {
    if (is_admin) {
      getAdminLandingPageData();
    }

    return () => {
      setData([]);
    };
  }, []);

  return (
    <>
      {is_admin ? (
        loading.status === "loading" ? (
          <Loader />
        ) : loading.status === "success" ? (
          <AdminLandingPage data={data} />
        ) : (
          <Error
            message={loading.message}
            imageHeight={"20vh"}
            retryFunction={getAdminLandingPageData}
          />
        )
      ) : (
        <NoAccess />
      )}
    </>
  );
}

export default AdminLandingPageContainer;
